import EventBus, { EVENTS } from '../eventBus';
import type { GeneralDialogCommand } from './showDialogCommand';
import type { DialogRequest } from './types';

export function requestDialog(req: DialogRequest, component: unknown) {
  const command: GeneralDialogCommand = {
    type: 'general',
    req: {
      requestData: req,
      component,
    },
  };
  EventBus.emit(EVENTS.SHOW_DIALOG, command);
}
